module.exports = __webpack_public_path__ + "static/media/Ես-բլբուլ-եմ-Մարիետա-Բադալյան.10e5f934.mp3";